/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popGetRewardTip.vue?vue&type=template&id=5c5a409c&scoped=true"
import script from "./popGetRewardTip.vue?vue&type=script&lang=js"
export * from "./popGetRewardTip.vue?vue&type=script&lang=js"
import style0 from "./popGetRewardTip.vue?vue&type=style&index=0&id=5c5a409c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5a409c",
  null
  
)

export default component.exports